/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { financingSourcesOwnFundsCopyCreate } from '../fn/own-funds/financing-sources-own-funds-copy-create';
import { FinancingSourcesOwnFundsCopyCreate$Params } from '../fn/own-funds/financing-sources-own-funds-copy-create';
import { financingSourcesOwnFundsCreate } from '../fn/own-funds/financing-sources-own-funds-create';
import { financingSourcesOwnFundsCreate$FormData } from '../fn/own-funds/financing-sources-own-funds-create-form-data';
import { FinancingSourcesOwnFundsCreate$FormData$Params } from '../fn/own-funds/financing-sources-own-funds-create-form-data';
import { FinancingSourcesOwnFundsCreate$Params } from '../fn/own-funds/financing-sources-own-funds-create';
import { financingSourcesOwnFundsCreate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-own-funds-create-x-www-form-urlencoded';
import { FinancingSourcesOwnFundsCreate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-own-funds-create-x-www-form-urlencoded';
import { financingSourcesOwnFundsDestroy } from '../fn/own-funds/financing-sources-own-funds-destroy';
import { FinancingSourcesOwnFundsDestroy$Params } from '../fn/own-funds/financing-sources-own-funds-destroy';
import { financingSourcesOwnFundsEnumsRetrieve } from '../fn/own-funds/financing-sources-own-funds-enums-retrieve';
import { FinancingSourcesOwnFundsEnumsRetrieve$Params } from '../fn/own-funds/financing-sources-own-funds-enums-retrieve';
import { financingSourcesOwnFundsList } from '../fn/own-funds/financing-sources-own-funds-list';
import { FinancingSourcesOwnFundsList$Params } from '../fn/own-funds/financing-sources-own-funds-list';
import { financingSourcesOwnFundsPartialUpdate } from '../fn/own-funds/financing-sources-own-funds-partial-update';
import { financingSourcesOwnFundsPartialUpdate$FormData } from '../fn/own-funds/financing-sources-own-funds-partial-update-form-data';
import { FinancingSourcesOwnFundsPartialUpdate$FormData$Params } from '../fn/own-funds/financing-sources-own-funds-partial-update-form-data';
import { FinancingSourcesOwnFundsPartialUpdate$Params } from '../fn/own-funds/financing-sources-own-funds-partial-update';
import { financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-own-funds-partial-update-x-www-form-urlencoded';
import { FinancingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-own-funds-partial-update-x-www-form-urlencoded';
import { financingSourcesOwnFundsRetrieve } from '../fn/own-funds/financing-sources-own-funds-retrieve';
import { FinancingSourcesOwnFundsRetrieve$Params } from '../fn/own-funds/financing-sources-own-funds-retrieve';
import { financingSourcesOwnFundsUpdate } from '../fn/own-funds/financing-sources-own-funds-update';
import { financingSourcesOwnFundsUpdate$FormData } from '../fn/own-funds/financing-sources-own-funds-update-form-data';
import { FinancingSourcesOwnFundsUpdate$FormData$Params } from '../fn/own-funds/financing-sources-own-funds-update-form-data';
import { FinancingSourcesOwnFundsUpdate$Params } from '../fn/own-funds/financing-sources-own-funds-update';
import { financingSourcesOwnFundsUpdate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-own-funds-update-x-www-form-urlencoded';
import { FinancingSourcesOwnFundsUpdate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-own-funds-update-x-www-form-urlencoded';
import { financingSourcesOwnFundsVariantsCopyCreate } from '../fn/own-funds/financing-sources-own-funds-variants-copy-create';
import { FinancingSourcesOwnFundsVariantsCopyCreate$Params } from '../fn/own-funds/financing-sources-own-funds-variants-copy-create';
import { financingSourcesOwnFundsVariantsCreate } from '../fn/own-funds/financing-sources-own-funds-variants-create';
import { financingSourcesOwnFundsVariantsCreate$FormData } from '../fn/own-funds/financing-sources-own-funds-variants-create-form-data';
import { FinancingSourcesOwnFundsVariantsCreate$FormData$Params } from '../fn/own-funds/financing-sources-own-funds-variants-create-form-data';
import { FinancingSourcesOwnFundsVariantsCreate$Params } from '../fn/own-funds/financing-sources-own-funds-variants-create';
import { financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-own-funds-variants-create-x-www-form-urlencoded';
import { FinancingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-own-funds-variants-create-x-www-form-urlencoded';
import { financingSourcesOwnFundsVariantsDestroy } from '../fn/own-funds/financing-sources-own-funds-variants-destroy';
import { FinancingSourcesOwnFundsVariantsDestroy$Params } from '../fn/own-funds/financing-sources-own-funds-variants-destroy';
import { financingSourcesOwnFundsVariantsList } from '../fn/own-funds/financing-sources-own-funds-variants-list';
import { FinancingSourcesOwnFundsVariantsList$Params } from '../fn/own-funds/financing-sources-own-funds-variants-list';
import { financingSourcesOwnFundsVariantsPartialUpdate } from '../fn/own-funds/financing-sources-own-funds-variants-partial-update';
import { financingSourcesOwnFundsVariantsPartialUpdate$FormData } from '../fn/own-funds/financing-sources-own-funds-variants-partial-update-form-data';
import { FinancingSourcesOwnFundsVariantsPartialUpdate$FormData$Params } from '../fn/own-funds/financing-sources-own-funds-variants-partial-update-form-data';
import { FinancingSourcesOwnFundsVariantsPartialUpdate$Params } from '../fn/own-funds/financing-sources-own-funds-variants-partial-update';
import { financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-own-funds-variants-partial-update-x-www-form-urlencoded';
import { FinancingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-own-funds-variants-partial-update-x-www-form-urlencoded';
import { financingSourcesOwnFundsVariantsRetrieve } from '../fn/own-funds/financing-sources-own-funds-variants-retrieve';
import { FinancingSourcesOwnFundsVariantsRetrieve$Params } from '../fn/own-funds/financing-sources-own-funds-variants-retrieve';
import { financingSourcesOwnFundsVariantsUpdate } from '../fn/own-funds/financing-sources-own-funds-variants-update';
import { financingSourcesOwnFundsVariantsUpdate$FormData } from '../fn/own-funds/financing-sources-own-funds-variants-update-form-data';
import { FinancingSourcesOwnFundsVariantsUpdate$FormData$Params } from '../fn/own-funds/financing-sources-own-funds-variants-update-form-data';
import { FinancingSourcesOwnFundsVariantsUpdate$Params } from '../fn/own-funds/financing-sources-own-funds-variants-update';
import { financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-own-funds-variants-update-x-www-form-urlencoded';
import { FinancingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-own-funds-variants-update-x-www-form-urlencoded';
import { financingSourcesUnblockOwnFundsVariantsCreate } from '../fn/own-funds/financing-sources-unblock-own-funds-variants-create';
import { financingSourcesUnblockOwnFundsVariantsCreate$FormData } from '../fn/own-funds/financing-sources-unblock-own-funds-variants-create-form-data';
import { FinancingSourcesUnblockOwnFundsVariantsCreate$FormData$Params } from '../fn/own-funds/financing-sources-unblock-own-funds-variants-create-form-data';
import { FinancingSourcesUnblockOwnFundsVariantsCreate$Params } from '../fn/own-funds/financing-sources-unblock-own-funds-variants-create';
import { financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded } from '../fn/own-funds/financing-sources-unblock-own-funds-variants-create-x-www-form-urlencoded';
import { FinancingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/own-funds/financing-sources-unblock-own-funds-variants-create-x-www-form-urlencoded';
import { BackendIdDto } from '../models/backend-id-dto';
import { BackendOwnFundDto } from '../models/backend-own-fund-dto';
import { BackendOwnFundEnumsDto } from '../models/backend-own-fund-enums-dto';
import { BackendOwnFundVariantDto } from '../models/backend-own-fund-variant-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiOwnFundsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `financingSourcesOwnFundsList()` */
  static readonly FinancingSourcesOwnFundsListPath = '/api/financing_sources/own_funds/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsList$Response(
    params?: FinancingSourcesOwnFundsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOwnFundDto>>> {
    return financingSourcesOwnFundsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsList(
    params?: FinancingSourcesOwnFundsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendOwnFundDto>> {
    return this.financingSourcesOwnFundsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendOwnFundDto>>): Array<BackendOwnFundDto> => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsCreate()` */
  static readonly FinancingSourcesOwnFundsCreatePath = '/api/financing_sources/own_funds/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsCreate$Response(
    params: FinancingSourcesOwnFundsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsCreate(
    params: FinancingSourcesOwnFundsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesOwnFundsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesOwnFundsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsCreate$FormData$Response(
    params: FinancingSourcesOwnFundsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsCreate$FormData(
    params: FinancingSourcesOwnFundsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsRetrieve()` */
  static readonly FinancingSourcesOwnFundsRetrievePath = '/api/financing_sources/own_funds/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsRetrieve$Response(
    params: FinancingSourcesOwnFundsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsRetrieve(
    params: FinancingSourcesOwnFundsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsUpdate()` */
  static readonly FinancingSourcesOwnFundsUpdatePath = '/api/financing_sources/own_funds/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsUpdate$Response(
    params: FinancingSourcesOwnFundsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsUpdate(
    params: FinancingSourcesOwnFundsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesOwnFundsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesOwnFundsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsUpdate$FormData$Response(
    params: FinancingSourcesOwnFundsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsUpdate$FormData(
    params: FinancingSourcesOwnFundsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsDestroy()` */
  static readonly FinancingSourcesOwnFundsDestroyPath = '/api/financing_sources/own_funds/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsDestroy$Response(
    params: FinancingSourcesOwnFundsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesOwnFundsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsDestroy(
    params: FinancingSourcesOwnFundsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesOwnFundsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsPartialUpdate()` */
  static readonly FinancingSourcesOwnFundsPartialUpdatePath = '/api/financing_sources/own_funds/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsPartialUpdate$Response(
    params: FinancingSourcesOwnFundsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsPartialUpdate(
    params: FinancingSourcesOwnFundsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsPartialUpdate$FormData$Response(
    params: FinancingSourcesOwnFundsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundDto>> {
    return financingSourcesOwnFundsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsPartialUpdate$FormData(
    params: FinancingSourcesOwnFundsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundDto> {
    return this.financingSourcesOwnFundsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundDto>): BackendOwnFundDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsCopyCreate()` */
  static readonly FinancingSourcesOwnFundsCopyCreatePath = '/api/financing_sources/own_funds/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsCopyCreate$Response(
    params: FinancingSourcesOwnFundsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesOwnFundsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsCopyCreate(
    params: FinancingSourcesOwnFundsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesOwnFundsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsEnumsRetrieve()` */
  static readonly FinancingSourcesOwnFundsEnumsRetrievePath = '/api/financing_sources/own_funds/enums/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsEnumsRetrieve$Response(
    params?: FinancingSourcesOwnFundsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundEnumsDto>> {
    return financingSourcesOwnFundsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsEnumsRetrieve(
    params?: FinancingSourcesOwnFundsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundEnumsDto> {
    return this.financingSourcesOwnFundsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundEnumsDto>): BackendOwnFundEnumsDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsList()` */
  static readonly FinancingSourcesOwnFundsVariantsListPath = '/api/financing_sources/own_funds_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsList$Response(
    params?: FinancingSourcesOwnFundsVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOwnFundVariantDto>>> {
    return financingSourcesOwnFundsVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsList(
    params?: FinancingSourcesOwnFundsVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendOwnFundVariantDto>> {
    return this.financingSourcesOwnFundsVariantsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendOwnFundVariantDto>>): Array<BackendOwnFundVariantDto> => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsCreate()` */
  static readonly FinancingSourcesOwnFundsVariantsCreatePath = '/api/financing_sources/own_funds_variants/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsVariantsCreate$Response(
    params: FinancingSourcesOwnFundsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsVariantsCreate(
    params: FinancingSourcesOwnFundsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsVariantsCreate$FormData$Response(
    params: FinancingSourcesOwnFundsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsVariantsCreate$FormData(
    params: FinancingSourcesOwnFundsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsRetrieve()` */
  static readonly FinancingSourcesOwnFundsVariantsRetrievePath = '/api/financing_sources/own_funds_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsRetrieve$Response(
    params: FinancingSourcesOwnFundsVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsRetrieve(
    params: FinancingSourcesOwnFundsVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsUpdate()` */
  static readonly FinancingSourcesOwnFundsVariantsUpdatePath = '/api/financing_sources/own_funds_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsVariantsUpdate$Response(
    params: FinancingSourcesOwnFundsVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsVariantsUpdate(
    params: FinancingSourcesOwnFundsVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsVariantsUpdate$FormData$Response(
    params: FinancingSourcesOwnFundsVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsVariantsUpdate$FormData(
    params: FinancingSourcesOwnFundsVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsDestroy()` */
  static readonly FinancingSourcesOwnFundsVariantsDestroyPath = '/api/financing_sources/own_funds_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsDestroy$Response(
    params: FinancingSourcesOwnFundsVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesOwnFundsVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsDestroy(
    params: FinancingSourcesOwnFundsVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesOwnFundsVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsPartialUpdate()` */
  static readonly FinancingSourcesOwnFundsVariantsPartialUpdatePath = '/api/financing_sources/own_funds_variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsVariantsPartialUpdate$Response(
    params: FinancingSourcesOwnFundsVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesOwnFundsVariantsPartialUpdate(
    params: FinancingSourcesOwnFundsVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded(
    params: FinancingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsVariantsPartialUpdate$FormData$Response(
    params: FinancingSourcesOwnFundsVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOwnFundVariantDto>> {
    return financingSourcesOwnFundsVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesOwnFundsVariantsPartialUpdate$FormData(
    params: FinancingSourcesOwnFundsVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOwnFundVariantDto> {
    return this.financingSourcesOwnFundsVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOwnFundVariantDto>): BackendOwnFundVariantDto => r.body),
    );
  }

  /** Path part for operation `financingSourcesOwnFundsVariantsCopyCreate()` */
  static readonly FinancingSourcesOwnFundsVariantsCopyCreatePath =
    '/api/financing_sources/own_funds_variants/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesOwnFundsVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsCopyCreate$Response(
    params: FinancingSourcesOwnFundsVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return financingSourcesOwnFundsVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesOwnFundsVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  financingSourcesOwnFundsVariantsCopyCreate(
    params: FinancingSourcesOwnFundsVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.financingSourcesOwnFundsVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `financingSourcesUnblockOwnFundsVariantsCreate()` */
  static readonly FinancingSourcesUnblockOwnFundsVariantsCreatePath =
    '/api/financing_sources/unblock-own-funds-variants/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockOwnFundsVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockOwnFundsVariantsCreate$Response(
    params: FinancingSourcesUnblockOwnFundsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockOwnFundsVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockOwnFundsVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  financingSourcesUnblockOwnFundsVariantsCreate(
    params: FinancingSourcesUnblockOwnFundsVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockOwnFundsVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded$Response(
    params: FinancingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded(
    params: FinancingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockOwnFundsVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `financingSourcesUnblockOwnFundsVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockOwnFundsVariantsCreate$FormData$Response(
    params: FinancingSourcesUnblockOwnFundsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendIdDto>> {
    return financingSourcesUnblockOwnFundsVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `financingSourcesUnblockOwnFundsVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  financingSourcesUnblockOwnFundsVariantsCreate$FormData(
    params: FinancingSourcesUnblockOwnFundsVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendIdDto> {
    return this.financingSourcesUnblockOwnFundsVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendIdDto>): BackendIdDto => r.body),
    );
  }
}
